export const vBeforeClose = (action,done)=>{
    if (action === 'confirm') {
        done(false)
    } else {
        done();
    }
}